import { render, staticRenderFns } from "./MsgDialog.vue?vue&type=template&id=0a89b6a0&scoped=true&"
import script from "./MsgDialog.vue?vue&type=script&lang=js&"
export * from "./MsgDialog.vue?vue&type=script&lang=js&"
import style0 from "./MsgDialog.vue?vue&type=style&index=0&id=0a89b6a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a89b6a0",
  null
  
)

export default component.exports